import React, { 
  createContext, 
  ReactNode, 
  Context,
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { Mode, Density,} from "@cloudscape-design/global-styles";
import { useLocalStorage } from 'usehooks-ts';

type ContextProviderProps = {children : ReactNode} 

export const GlobalContext: Context<any> = createContext("globalContext");
export const GlobalContextProvider = ({ children }: ContextProviderProps) => {
  const [theme, setTheme] = useLocalStorage<Mode>("theme", Mode.Light)
  const [density, setDensity] = useLocalStorage<Density>("density", Density.Comfortable)
  const [activeHref, setActiveHref] = useLocalStorage<String>("activeHref", "/");
  const [seriesContent, setSeriesContent] = useLocalStorage<any>("seriesContent", "series");
  const [accountContent, setAccountContent] = useLocalStorage<any>("accountContent", "profile");
  const [userAttributes, setUserAttributes] = useLocalStorage<any>("userAttributes", {});
  // const [userAttributes, setUserAttributes] = useState<any>();
  const [authInitialState, setAuthInitialState] = useState("signIn");
  const [pathname, setPathname] = useLocalStorage("pathname", "/")
  // const [driverId, setDriverId] = useLocalStorage<string>("driverId", "");
  
  return (
      <GlobalContext.Provider value={{ 
        theme, setTheme, 
        activeHref, setActiveHref, 
        density, setDensity, 
        userAttributes, setUserAttributes,
        authInitialState, setAuthInitialState,
        seriesContent, setSeriesContent,
        accountContent, setAccountContent,
        pathname, setPathname,
        // driverId, setDriverId,
      }}>
          {children}
      </GlobalContext.Provider>
  );
};


export const ContentContext: Context<any> = createContext("contentContext");
export const ContentContextProvider = ({ children }: ContextProviderProps) => {
  const [activeSeriesSection, setActiveSeriesSection] = useState();

  return (
      <ContentContext.Provider value={{ 
        activeSeriesSection, setActiveSeriesSection, 
      }}>
          {children}
      </ContentContext.Provider>
  );
};